import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

interface BulkOperationProgressCardProps {
  failedLabels: string[];
  hasFailures: boolean;
  isSettled: boolean;
  onClose: () => void;
  percentComplete: number;
  statusText: string;
  title: string;
}

export default function BulkOperationProgressCard({
  failedLabels,
  hasFailures,
  isSettled,
  onClose,
  percentComplete,
  statusText,
  title,
}: BulkOperationProgressCardProps) {
  return (
    <Paper
      data-test-id="bulk-operation-progress-card"
      elevation={4}
      sx={{
        border: 1,
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 2,
        width: 280,
      }}
    >
      <Box
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{title}</Typography>

        {isSettled ? (
          <IconButton aria-label={t('actions.close')} onClick={onClose} size="small">
            <Close sx={{ fontSize: '16px' }} />
          </IconButton>
        ) : null}
      </Box>

      <LinearProgress
        color={hasFailures ? 'error' : 'primary'}
        value={percentComplete}
        variant="determinate"
      />

      <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
        {statusText}
      </Typography>

      {failedLabels.length ? (
        <Typography
          sx={{ color: 'error.main', fontSize: '12px', wordBreak: 'break-word' }}
        >
          {failedLabels.join(', ')}
        </Typography>
      ) : null}
    </Paper>
  );
}
